import { render, staticRenderFns } from "./fcwpLogo.vue?vue&type=template&id=c70e4a0e&"
import script from "./fcwpLogo.vue?vue&type=script&lang=js&"
export * from "./fcwpLogo.vue?vue&type=script&lang=js&"
import style0 from "./fcwpLogo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports